module.exports = __webpack_public_path__ + "static/media/210옴니고딕040.845638d8.ttf";